module.exports = "/_next/static/images/technologyDeployment-482fea2464d06dfdece12e617865572d.webp";